const initialState = {
  init: true,
  topState: {
    back: true,
    title: "",
    menu: true,
    main: false,
  },
  alertOpen: false,
  appCardOpen: false,
  favAlertOpen: false,
  sidebarOpen: false,
  hideAlertOpen: false,
  linkAlert: "",
};

export const INIT_TOP = "INIT_TOP";
export const initTop = () => ({
  type: INIT_TOP,
});

export const LOAD_DATA = "LOAD_DATA";
export const loadAction = (data) => ({
  type: LOAD_DATA,
  payload: data,
});

export const LOAD_ALERT = "LOAD_ALERT";
export const loadAlert = (data) => ({
  type: LOAD_ALERT,
  payload: data,
});

export const LOAD_APP_CARD = "LOAD_APP_CARD";
export const loadAppCard = (data) => ({
  type: LOAD_APP_CARD,
  payload: data,
});

export const LOAD_FAV_ALERT = "LOAD_FAV_ALERT";
export const loadFavAlert = (data) => ({
  type: LOAD_FAV_ALERT,
  payload: data,
});

export const LOAD_SIDEBAR = "LOAD_SIDEBAR";
export const loadSidebar = (data) => ({
  type: LOAD_SIDEBAR,
  payload: data,
});

export const LOAD_HIDE_ALERT = "LOAD_HIDE_ALERT";
export const loadHideAlert = (data) => ({
  type: LOAD_HIDE_ALERT,
  payload: data,
});

export const LOAD_LINK_ALERT = "LOAD_LINK_ALERT";
export const loadLinkAlert = (data) => ({
  type: LOAD_LINK_ALERT,
  payload: data,
});

export default function topReducer(state = initialState, action) {
  const { type, payload, error } = action;
  console.log("payload", payload);
  switch (type) {
    case INIT_TOP:
      return {
        init: true,
        topState: {
          back: true,
          title: "",
          menu: true,
          main: false,
        },
      };
    case LOAD_DATA:
      return {
        ...state,
        topState: {
          ...state.topState,
          ...payload,
        },
        init: false,
      };
    case LOAD_ALERT:
      return {
        ...state,
        alertOpen: payload,
      };
    case LOAD_APP_CARD:
      return {
        ...state,
        appCardOpen: payload,
      };
    case LOAD_FAV_ALERT:
      return {
        ...state,
        favAlertOpen: payload,
      };
    case LOAD_SIDEBAR:
      return {
        ...state,
        sidebarOpen: payload,
      };
    case LOAD_HIDE_ALERT:
      return {
        ...state,
        hideAlertOpen: payload,
      };
    case LOAD_LINK_ALERT:
      return {
        ...state,
        linkAlert: payload,
      };
    default:
      return state;
  }
}
